module.exports = __webpack_public_path__ + "static/media/ProximaNova.99e6f15d.ttf";